import {useCallback, useReducer} from 'react'
import {getGroupActions} from './actions'
import Reducer, {InitialState} from './reducer'

export const useGetGroupActions = () => {
  const [state, dispatch] = useReducer(Reducer, InitialState)

  const call = useCallback(
    ({group_id, params}) => {
      getGroupActions(dispatch, {group_id, params})
    },
    [dispatch]
  )

  return {state, dispatch, call}
}
